import 'babel-polyfill'
import Util from './util'
import Rails from 'rails-ujs'

const util = new Util()

// /results/show 問い合わせフォーム
class Base {
  constructor () {
    util.checkUA()
    util.setParams()
  }

  /**
   * 問い合わせフォームのajax処理
   */
  setContactFormEv () {
    // バリデーション以外のシステムエラー・通信エラーを表示
    const globalError = (msg) => {
      const txt = msg.split(':')[1]
      document.querySelector('[data-errormsg="globalError"]').innerText = txt
      document.querySelector('[data-enablecheck="recruit-form"]').style.display = 'none'
    }

    // バリデーションメッセージ全消去
    const errorBlank = (errorTgts) => {
      for (let i = 0; i < errorTgts.length; i++) {
        errorTgts[i].innerText = ''
      }
    }

    // バリデーションメッセージ表示
    const showError = (errorData) => {
      Object.keys(errorData).forEach(function (key) {
        if (key === 'zip1' || key === 'zip2') {
          const tgt = document.querySelector('[data-errormsg="zip"]')
          if (!tgt.innerText) {
            tgt.innerText = '郵便番号' + errorData[key]
          }
        } else {
          const tgt = document.querySelector('[data-errormsg="' + key + '"]')
          tgt.innerText = tgt.getAttribute('data-errormsgLabel') + errorData[key]
        }
      })
    }

    // 通信成功時
    jQuery(document).on("ajax:success", "#user-entry-form", function(e) {
      if (!e.originalEvent.detail[0]) {
        globalError('system:システムエラーです。管理者にご連絡ください')
      }

      const result = e.originalEvent.detail[0].result
      const data = e.originalEvent.detail[0].data
      const msg = e.originalEvent.detail[0].msg

      const errorTgts = document.querySelectorAll('[data-errormsg]')
      errorBlank(errorTgts)

      if (result === 'ng') {
        if (msg.match('validerror')) {
          showError(data)
        } else {
          globalError(msg)
        }
      } else if (result === 'success') {
        location.href = '/thanks'
      } else {
        globalError('system:システムエラーです。管理者にご連絡ください')
      }
    });

    // 通信失敗時
    jQuery(document).on("ajax:error", "#user-entry-form", function(e) {
      globalError('system:システムエラーです。管理者にご連絡ください')
    });
  }

  setZip2Addr () {
    const tgt = document.querySelector('[name="inquiry[zip2]"]')
    if (!tgt) return false
    tgt.addEventListener('keyup', () => {
      AjaxZip3.zip2addr('inquiry[zip1]','inquiry[zip2]','inquiry[address]','inquiry[address]', '', '', false)
    }, false)
  }

  /**
   * フロントメイン処理
   */
  main () {
    this.setContactFormEv()
    this.setZip2Addr()
  }

  init () {
    this.main()
  }
}

const base = new Base()

document.addEventListener("DOMContentLoaded", () => {
  base.init()
}, false)

Rails.start()
